import { configureStore } from '@reduxjs/toolkit'
import authReducer from './auth/reducer'
import avatarReducer from './avatar/reducer'
import homeReducer from './home/reducer'
import profileReducer from './profile/reducer'
import sendingReducer from './sending/reducer'


export default configureStore({
  reducer: {
    auth: authReducer,
    avatar: avatarReducer,
    home: homeReducer,
    profile: profileReducer,
    sending: sendingReducer,
  },
});
